// 异步按钮状态工具 / Async button state helpers.
// 统一处理会请求服务端的按钮：立即禁用并显示 spinner，完成后恢复原始内容。
// Centralizes server-bound button feedback: disable immediately, show a spinner,
// and restore the original content when the async work settles.

/**
 * 开始按钮 loading 态，并返回幂等恢复函数。
 * Start a button loading state and return an idempotent restore callback.
 */
export function startButtonLoading(
  button: HTMLButtonElement,
  label: string,
): () => void {
  const originalHtml = button.innerHTML;
  const originalDisabled = button.disabled;
  let restored = false;

  button.disabled = true;
  button.classList.add("is-loading");
  button.setAttribute("aria-busy", "true");

  const spinner = document.createElement("span");
  spinner.className = "button-spinner";
  spinner.setAttribute("aria-hidden", "true");

  const text = document.createElement("span");
  text.textContent = label;

  button.replaceChildren(spinner, text);

  return () => {
    if (restored) return;
    restored = true;
    button.disabled = originalDisabled;
    button.classList.remove("is-loading");
    button.removeAttribute("aria-busy");
    button.innerHTML = originalHtml;
  };
}

/**
 * 包裹异步任务，自动维护按钮 loading 态。
 * Wrap an async task with automatic button loading state.
 */
export async function withButtonLoading<T>(
  button: HTMLButtonElement,
  label: string,
  task: () => Promise<T>,
): Promise<T> {
  const restore = startButtonLoading(button, label);
  try {
    return await task();
  } finally {
    restore();
  }
}
